const faqEntry = (question, answer) => ({ question, answer });

const faqData = [
  faqEntry(
    "What kind of work do you do?",
    "I take digital products from research to reality. Every project follows a deliberate, end-to-end process: starting with user needs and market research, moving into component systems and high-fidelity UI in Figma, and developing the final product in React, Next.js, and Tailwind. I bridge the gap between design and code to ensure the system stays identical from concept to browser."
  ),
  faqEntry(
    "What is your background?",
    [
      "I started building with HTML and CSS as a teenager, hooked on the pure logic of the browser: write the structure, solve the layout step-by-step, and make it functional.",
      "When I picked up Figma in 2021, design didn't replace my code mindset. Instead, it strengthened it. Researching user needs and working out UX flows gave my development clear architectural direction. Instead of building components in isolation, I started thinking in complete, repeatable systems.",
      "Today, I focus on building responsive, accessible front-end web applications with React, Next.js, and Tailwind CSS. Because I understand both UX design and front-end code, I bridge the gap between design concepts and production-ready interfaces. I make sure everything looks right, handles data cleanly, and performs smoothly in the real world.",
    ].join("\n\n")
  ),
  faqEntry(
    "What is in your stack, and do you do backend?",
    "Figma; React, Next.js, TypeScript, Tailwind CSS, and DaisyUI; semantic HTML, modern CSS, and ES6+ JavaScript; Git. I have a foundational knowledge of backend development: covering APIs, databases, and data fetching, while deeper backend services are a collaboration with backend engineers."
  ),
  faqEntry(
    "What is the best way to contact you?",
    "Email avida2c@gmail.com or use the contact form on this site. I typically respond within 24 business hours."
  ),
];

export default faqData;
